(function Offers($, Adzuki)
{
	"use strict";

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/Offers/index/', '/Offers/expired/', '/AllInclusiveProperties/view/', '/Offers/calendar/', '/ReservationAmenities/add/', '/ReservationAmenities/edit/'], function onload()
		{
			$('.details').click(function showDetails(e) {
				var id = $(this).data('offer-id'),
					body;

				e.preventDefault();
				$(".modal-dialog").addClass('modal-lg');

				Adzuki.Ajax.get('/Offers/getDescription/' + id).then(function success(data) {
					body = '<p><img src="' + Adzuki.base_uri + data.logo + '"></p>';
					body += data.body;

					$modal.find('.modal-title').text(data.vendor_name + ' - ' + data.offer_name);
					$modal.find('.modal-body').html(body);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});
		});

		// used throughout erez app
		$('.result-special-sale-details').click(function showSpecialSaleDetails(e) {
			var special_sale_id = $(this).data("special-sale-id"),
				$modal          = $(".modal");

			e.preventDefault();

			$modal.addClass('wide');
			$modal.find('.modal-body').text('Loading Special Sale Details...');

			Adzuki.Ajax.get('/Offers/detail/' + special_sale_id)
			.then(function success(html) {
				$modal.find('.modal-body').html(html);
				$modal.find('[data-toggle^="tooltip"]').tooltip();
			});

			$modal.find('.modal-title').text('Special Sale Details');
			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});
	});

}(jQuery, window.Adzuki || {}));
